import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { Shortcut } from '@/hooks/use-keyboard-shortcuts';
import { Keyboard } from 'lucide-react';

interface Props {
  open: boolean;
  onClose: () => void;
  shortcuts: Shortcut[];
}

// Modal listing the available keyboard shortcuts. Triggered by `?`. We
// receive the list from the parent so the same dialog works on any page
// (dashboard has its own bindings; settings could add some too).
export function ShortcutsHelp({ open, onClose, shortcuts }: Props) {
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Keyboard className="size-4" />
            Atajos de teclado
          </DialogTitle>
          <DialogDescription>Funcionan cuando no estás escribiendo en un input.</DialogDescription>
        </DialogHeader>
        <ul className="grid gap-2">
          {shortcuts.map((s) => (
            <li
              key={s.key}
              className="flex items-center justify-between rounded-md border border-border bg-popover px-3 py-2 text-sm"
            >
              <span className="text-muted-foreground">{s.description}</span>
              <kbd className="rounded border border-border bg-card px-1.5 py-0.5 font-mono text-xs">
                {s.key === ' ' ? 'Space' : s.key}
              </kbd>
            </li>
          ))}
        </ul>
        <div className="flex justify-end pt-2">
          <Button variant="ghost" size="sm" onClick={onClose}>
            Cerrar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
